import React from "react";

import { TranslatedText } from "@plex/culture-react";

import { commonMessages } from "infrastructure/localization";

import { ErrorContent } from "../error-content";
import { ErrorResistantContent } from "../ErrorResistantContent";

import styles from "./AppError.module.scss";

export const AppError: React.FC = () => {
  return (
    <ErrorContent className={styles.appError}>
      <h1>
        <ErrorResistantContent fallbackComponentFactory={() => "Application Error"}>
          <TranslatedText messageId={commonMessages.title("appError").value} />
        </ErrorResistantContent>
      </h1>
    </ErrorContent>
  );
};
